import { formatFilterPrice } from 'utils/formatFilterPrice';

export const formatPriceBeforeModification = (price?: string | number | null) => {
    if (price === null || price === undefined) return undefined;

    const priceString = price.toString().trim();

    if (!priceString) return undefined;

    const normalizedPrice = priceString.replace(/\s/g, '').replace(',', '.');

    if (!Number.isFinite(Number(normalizedPrice))) {
        return priceString;
    }

    return formatFilterPrice(priceString)?.toString();
};
